import { ColumnType, Row } from "@asayinc/component-library";

import { PROXY_LABEL, VOTE_STATUS_LABEL } from "src/constants/labels";
import { ListProxyCommunication } from "src/store/proxy/types";
import { ListCommunication } from "src/store/types";

export type ColumnDataHelpers = {
  getSort: (sortKey: string) => "asc" | "desc" | undefined;
  onOrderingChange: (data: unknown, sortKey: string) => void;
};

type ColumnData = {
  type: ColumnType;
  ticker: ColumnType;
  issuer: ColumnType;
  approvedAt: ColumnType;
  voted: ColumnType;
};

export function getColumns() {
  return ["type", "ticker", "issuer", "approvedAt", "voted"];
}

export function getColumnData({
  getSort,
  onOrderingChange,
}: ColumnDataHelpers): ColumnData {
  return {
    type: {
      sort: getSort("type"),
      sortFn: (data: unknown) => onOrderingChange(data, "type"),
      style: "text",
      title: "Type",
      tdBodyProps: {
        textProps: {
          weight: 600,
        },
      },
    },
    ticker: {
      style: "text",
      title: "Ticker",
    },
    issuer: {
      style: "text",
      title: "Issuer",
    },
    approvedAt: {
      sort: getSort("proxy_event__approved_at"),
      sortFn: (data: unknown) =>
        onOrderingChange(data, "proxy_event__approved_at"),
      style: "text",
      title: "Approved at",
    },
    voted: {
      style: "text",
      title: "Voted",
      width: "120px",
    },
  };
}

export function getRowData(
  communications: ListProxyCommunication[],
  onRowClick: (communication: ListCommunication) => void,
  selectedCommunication: ListCommunication | null | undefined
): Row[] {
  return communications.map((communication, idx) => {
    const handleRowClick = (data: unknown) => {
      const { communication } = data as {
        communication: ListProxyCommunication;
        idx: string;
      };
      onRowClick(communication);
    };

    const {
      id,
      proxyEvent: { approvedAt, type },
      security: { issuerName, ticker },
      voteStatus,
    } = communication;
    const rowData = {
      type: {
        content: PROXY_LABEL[type] || "-",
        clickHandler: handleRowClick,
      },
      ticker: {
        content: ticker || "-",
        clickHandler: handleRowClick,
      },
      issuer: {
        content: issuerName || "-",
        clickHandler: handleRowClick,
      },
      approvedAt: {
        content: approvedAt || "-",
        clickHandler: handleRowClick,
      },
      voted: {
        content: VOTE_STATUS_LABEL[voteStatus] || "-",
        clickHandler: handleRowClick,
      },
    };

    return {
      id: id,
      data: { communication, idx },
      rowData,
      highlighted: selectedCommunication?.id === communication.id,
    };
  });
}
